'use client';

import styles from '@styles/Header/user-drawer-nav.module.scss';
import { AccountUserButton } from './AccountUserButton';

/**
 * The account menu inside the mobile drawer.
 *
 * Nothing but Clerk's own user button, which is what the desktop header shows too — the avatar, the
 * name and email, and one menu carrying favourites, API keys, profile and sign-out.
 *
 * It used to be a hand-rolled list of links beside it. That list was a second place to maintain
 * every account link, and it had already fallen out of step with the desktop menu; the entries that
 * are still wanted live on `AccountUserButton` now, where both breakpoints read them from.
 */
const UserDrawerNav: React.FC = () => (
  <div className={styles.user__nav__container}>
    <div className={styles.nav__head}>
      <AccountUserButton />
    </div>
  </div>
);

export default UserDrawerNav;
